// Función para obtener los metafields del cliente
function obtenerMetafieldsCliente() {
  try {
    // Buscar el elemento que contiene los datos
    const dataElement = document.getElementById('customer-metafields-data');
    if (!dataElement) {
      return null;
    }

    // Parsear los datos JSON
    return JSON.parse(dataElement.textContent);
  } catch (error) {
    console.error('Error al obtener metafields:', error);
    return null;
  }
}

// Función para autocompletar el formulario
function autocompletarFormularioBsale(customerData) {
  // Obtener referencias a los campos usando los IDs correctos
  const campos = {
    rut: document.getElementById('cart_rut_lc'),
    razonSocial: document.getElementById('cart_razon_social_lc'),
    giro: document.getElementById('cart_giro_lc'),
    region: document.getElementById('cart_region_lc'),
    comuna: document.getElementById('cart_comuna_lc'),
    direccionTributaria: document.getElementById('cart_direccion_tributaria_lc')
  };

  // Verificar que tenemos los datos y los campos existen
  if (customerData && customerData.metafields && customerData.metafields.custom) {
    const metafields = customerData.metafields.custom;
    
    // Asignar los valores a los campos
    if (campos.rut) campos.rut.innerText = metafields.rut_empresa || '';
    if (campos.razonSocial) campos.razonSocial.innerText = metafields.razon_social || '';
    if (campos.giro) campos.giro.innerText = metafields.giro || '';
    if (campos.region) campos.region.innerText = metafields.region || '';
    if (campos.comuna) campos.comuna.innerText = metafields.comuna || '';
    if (campos.direccionTributaria) campos.direccionTributaria.innerText = metafields.direccion_tributaria || '';
  }
}

// Inicializar cuando el documento esté listo
document.addEventListener('DOMContentLoaded', function() {
  // Verificar si estamos en la página del carrito y si existe el formulario de facturación
  if (document.getElementById('section__billing-form')) {
    // Marcar automáticamente la opción de factura
    const facturaRadio = document.getElementById('checkout_bill_option');
    if (facturaRadio) {
      facturaRadio.checked = true;
      facturaRadio.dispatchEvent(new Event('change'));
    }

    // Obtener y mostrar los datos del cliente
    const customerData = obtenerMetafieldsCliente();
    if (customerData) {
      autocompletarFormularioBsale(customerData);
    }
  }
}); 